/* eslint-disable */
import React, { useState } from 'react';

import {
  baseDateFormat,
  baseDateFormatting,
  baseTimeFormatting,
} from '../../../../../../../common/helper';

import { useTranslate } from '../../../../../../../hooks';
import { useCancelSwap } from '../../api';

import { EditSwapShiftType, EmpSwapCardType } from '../../types';

import { EmpNameCard } from '../../swap-shift/components';
import CloseIcon from '@mui/icons-material/Close';
import { Modal } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import {
  Button,
  DateField,
  ModalActions,
} from '../../../../../../../components';

import './editShiftSwap.css';

const EmpSwapCard = ({ data }: EmpSwapCardType) => {
  const { translate } = useTranslate();

  return (
    <div className="swap-edit-emp-card-container">
      <EmpNameCard
        empName={data?.name}
        designation={data?.departmentName}
        profilePic={data?.profileImage}
      />

      <table className="emp-card-table">
        <thead className="emp-card-table-thead">
          <tr className="emp-card-table-head-row">
            <th className="emp-card-table-th" align="center">
              <p className="emp-card-table-th-txt">{translate('Date')}</p>
            </th>
            <th className="emp-card-table-th" align="center">
              <p className="emp-card-table-th-txt">{translate('Time')}</p>
            </th>
            <th className="emp-card-table-th" align="center">
              <p className="emp-card-table-th-txt">{translate('Shift')}</p>
            </th>
            <th className="emp-card-table-th" align="center">
              <p className="emp-card-table-th-txt">{translate('Timezone')}</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="emp-card-date-cell" align="center">
              <p
                className={`emp-card-table-txt ${
                  data?.isToday && 'font-success'
                }`}
              >
                {baseDateFormat(data?.date, baseDateFormatting)}
              </p>
            </td>
            <td className="emp-card-time-cell" align="center">
              <div className="emp-card-time-container">
                {data?.isWeekOff ? (
                  <span className="font-week-off">{translate('Week Off')}</span>
                ) : (
                  <>
                    {data?.startTime ? (
                      <DateField
                        value={data?.startTime}
                        offset={data?.timezone?.offset}
                        format={baseTimeFormatting}
                      />
                    ) : (
                      '-'
                    )}
                    &nbsp; -&nbsp;
                    {data?.endTime ? (
                      <DateField
                        value={data?.endTime}
                        offset={data?.timezone?.offset}
                        format={baseTimeFormatting}
                      />
                    ) : (
                      '-'
                    )}
                  </>
                )}
              </div>
            </td>
            <td className="emp-card-timezone" align="center">
              <p
                className={`emp-card-table-txt ${
                  data?.isToday && 'font-success'
                }`}
              >
                {data?.code || data?.shift?.code}
              </p>
            </td>
            <td className="emp-card-table-txt">
              {data?.timezone?.name ?? '-'}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export function EditSwap({ data, toggleModal, onEdited }: EditSwapShiftType) {
  const { translate } = useTranslate();

  const [openConfirmCancelationModal, setOpenConfirmCancelationModal] =
    useState(false);

  const { cancelSwap: _cancelSwap, isLoading } = useCancelSwap();

  const cancelSwap = async () => {
    await _cancelSwap({
      employeeId: data?.employee.id,
      date: data?.date,
    });
    onEdited();
    closeModal();
    toggleModal();
  };

  const closeModal = () => {
    setOpenConfirmCancelationModal(false);
  };

  return (
    <>
      <div className="swap-edit-container base-modal">
        <div className="swap-conf-title-sec">
          <p className="swap-conf-title-sec bold-txt">
            {baseDateFormat(data?.date, baseDateFormatting)}
          </p>
          <div className="swap-conf-close" onClick={toggleModal}>
            <CloseIcon style={{ color: '#9CA3AF' }} />
          </div>
        </div>
        <div className="swap-edit-body">
          <EmpSwapCard
            data={{
              ...data,
              name: data?.employee.name,
              profileImage: data?.employee.profilePic,
              departmentName: data?.employee.department,
            }}
          />
          <div className="swap-icon-sec">
            <i className="las la-exchange-alt swap-icon"></i>
          </div>
          <EmpSwapCard
            data={{
              ...data?.swappedWith,
              isSwapped: data?.swappedWith?.shift?.isSwapped,
              isWeekOff: data?.swappedWith?.shift?.isWeekOff,
              date: data?.swappedWith?.shift?.date,
              startTime: data?.swappedWith?.shift?.startTime,
              endTime: data?.swappedWith?.shift?.endTime,
              timezone: data?.swappedWith?.shift.timezone,
            }}
          />
        </div>
        <div className="swap-edit-action-sec">
          <Button
            className="primary-btn global-btn swap-cancel-btn"
            onClick={() => setOpenConfirmCancelationModal(true)}
          >
            {translate('Cancel Swap')}
          </Button>
        </div>
      </div>

      <Modal open={openConfirmCancelationModal} onClose={closeModal}>
        <div className="base-modal confirm-container">
          <div className="swap-edit-confirm">
            <WarningIcon className="warning-icon" />
            <div className="swap-edit-message">
              {translate('Are you sure you want to cancel the swapped shift?')}
            </div>
          </div>
          <ModalActions
            isSubmitting={isLoading}
            onCancel={closeModal}
            onSubmit={cancelSwap}
          />
        </div>
      </Modal>
    </>
  );
}
